import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'
import { IBaseline } from 'features/Map/interfaces/Maps'
import { HMCATableViewMode } from 'features/RegulatoryTools/HCAMCA/Components/Tables'

export const getBaselineInfo = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    baselineInfo: build.query<IBaseline, string>({
      query: (baselineId) => `/baseline/${baselineId}`,
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IBaseline
      }
    }),
    HMCABaselineInfo: build.query<IBaseline, HMCATableViewMode>({
      query: (regulatoryViewType) =>
        regulatoryViewType === HMCATableViewMode.HMCA
          ? '/consequencearea/assessments/current'
          : '/classlocation/assessments/current',
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IBaseline
      }
    })
  })
})

export const { useBaselineInfoQuery, useHMCABaselineInfoQuery } =
  getBaselineInfo
